import React from "react";
import SEO from "../Common/SEO";

const QuoteModal = () => {
  return (
    <>
      <SEO 
        title="Get a Quote | Custom Cart Manufacturing"
        description="Request a quote for custom tricycle carts, ice cream carts, and e-carts from Cart Studio. We provide tailored mobility solutions for your business needs."
      />
      <div className="section pb-0 bg-white">
        <div
          className=" section-title   py-[15px] lg:py-[30px]"
          data-aos="fade-up"
        >
          <span className="subtitle">Request a Quote</span>
          <h1>GET A PRICE ESTIMATE FOR YOUR CUSTOM CART</h1>
        </div>
      <form className="space-y-6 container">
        {/* Grid for input fields */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div>
            <label
              htmlFor="firstName"
              className="block font-medium text-gray-700"
            >
              First Name *
            </label>
            <input
              type="text"
              id="firstName"
              required
              className="mt-1 w-full rounded border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
          </div>

          <div>
            <label
              htmlFor="lastName"
              className="block font-medium text-gray-700"
            >
              Last Name *
            </label>
            <input
              type="text"
              id="lastName"
              required
              className="mt-1 w-full rounded border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
          </div>

          <div>
            <label htmlFor="email" className="block font-medium text-gray-700">
              Email *
            </label>
            <input
              type="email"
              id="email"
              required
              className="mt-1 w-full rounded border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
          </div>

          <div>
            <label htmlFor="phone" className="block font-medium text-gray-700">
              Phone *
            </label>
            <input
              type="tel"
              id="phone"
              required
              className="mt-1 w-full rounded border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
          </div>

          <div>
            <label
              htmlFor="country"
              className="block font-medium text-gray-700"
            >
              Country *
            </label>
            <input
              type="text"
              id="country"
              required
              className="mt-1 w-full rounded border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
            />
          </div>
        </div>

        {/* Full width Textarea */}
        <div>
          <label htmlFor="message" className="block font-medium text-gray-700">
            What do you plan to sell? *
          </label>
          <textarea
            id="message"
            rows="4"
            required
            className="mt-1 w-full rounded border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-orange-400"
          ></textarea>
        </div>

        {/* Checkbox */}
        <div className="mb-4">
          <label className="inline-flex items-start space-x-2">
            <input
              type="checkbox"
              className="mt-1 h-4 w-4 text-orange-600 border-gray-300 rounded focus:ring-orange-500"
              required
            />
            <span className="text-sm text-gray-700">
              I have read the{" "}
              <a
                href="https://www.tekneitalia.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange-600 underline hover:text-orange-800"
              >
                privacy
              </a>{" "}
              policy and I consent to the processing of personal data.
            </span>
          </label>
        </div>

        {/* <div className="flex items-start">
        <input type="checkbox" id="agree" required className="mt-1 mr-2" />
        <label htmlFor="agree" className="text-gray-700 text-sm">
          I agree to the terms and conditions *
        </label>
      </div> */}

        {/* Submit Button */}
        <div className="mb-4">
          <button
            type="submit"
            className="bg-orange-600 hover:bg-orange-700 text-white font-medium px-6 py-2 rounded"
          >
            Submit
          </button>
        </div>
      </form>
      </div>
    </>
  );
};

export default QuoteModal;
